/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  arSummaryData,
  arSummaryFldData,
} from '../../ARSummaryByMfg/store/actions';
import * as accActiontypes from '../../ReqAccReceivable/store/actiontypes';
import { getAcctRecvAllMfgApiErrorMessage } from '../../apiErrorUtils';

export const arSummaryAllTblData = (val) => {
  return { type: actiontypes.AR_ALL_TBL_DATA, payload: val };
};

export const arSummaryAllQtrData = (val) => {
  return { type: actiontypes.AR_ALL_FLD_DATA, payload: val };
};

export const getArSummarySigleRpc = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_ALL_ALL}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_SGL_TBL_DATA,
        payload: response.data,
      });
      let arSumData = {
        [val.rebateProgramCode]:
          response.data.acctRecveivableSummaryForAllMfgAllRpc,
      };
      let arSumSingleHeaderData = {
        [val.rebateProgramCode]: data,
      };
      dispatch(arSummaryData(arSumData));
      dispatch(arSummaryFldData(arSumSingleHeaderData));
    })
    .catch((error) => {
      const message = getAcctRecvAllMfgApiErrorMessage(error);
      if (message) {
        dispatch({ type: accActiontypes.ACC_ERR_MSG, payload: [message] });
      }
      dispatch({ type: actiontypes.AR_SGL_TBL_DATA, payload: null });
    });
};

export const resetARSummaryByMfgAllData = () => {
  return { type: actiontypes.AR_SUMMERY_MFG_ALL_FIELD_CLEAR_REDUX };
};
